import * as types from './types';

export const resetState = () => ({
  type: types.VACANCY_DOCUMENTS_RESET_STATE
});

export const setFormLoading = (isFormLoading) => ({
  type: types.VACANCY_DOCUMENTS_SET_FORM_LOADING,
  isFormLoading
});

export const setVacancyDocuments = (documents) => ({
  type: types.VACANCY_DOCUMENTS_SET_VACANCY_DOCUMENTS,
  documents
});

export const getVacancyDocuments = (schoolId, vacancyId) => ({
  type: types.VACANCY_DOCUMENTS_GET_VACANCY_DOCUMENTS,
  schoolId,
  vacancyId,
});

export const deleteVacancyDocument = (schoolId, vacancyId, documentId) => ({
  type: types.VACANCY_DOCUMENTS_DELETE_VACANCY_DOCUMENT,
  schoolId,
  vacancyId,
  documentId
});

export const updateVacancyDocument = (schoolId, vacancyId, documentId, document) => ({
  type: types.VACANCY_DOCUMENTS_UPDATE_VACANCY_DOCUMENT,
  schoolId,
  vacancyId,
  documentId,
  document
});

export const addVacancyDocument = (schoolId, vacancyId, virtualDocumentId, document) => ({
  type: types.VACANCY_DOCUMENTS_ADD_VACANCY_DOCUMENT,
  schoolId,
  vacancyId,
  virtualDocumentId,
  document
});

export const setNewVacancyDocument = (vacancyDocument) => ({
  type: types.VACANCY_DOCUMENTS_SET_NEW_VACANCY_DOCUMENT,
  vacancyDocument
});

export const setDocumentAdding = (isDocumentAdding) => ({
  type: types.VACANCY_DOCUMENTS_SET_DOCUMENT_ADDING,
  isDocumentAdding
});

export const setDocumentRemoving = (isDocumentRemoving) => ({
  type: types.VACANCY_DOCUMENTS_SET_DOCUMENT_REMOVING,
  isDocumentRemoving
});

export const setDocumentUpdating = (isDocumentUpdating) => ({
  type: types.VACANCY_DOCUMENTS_SET_DOCUMENT_UPDATING,
  isDocumentUpdating
});


// WEBPACK FOOTER //
// ./src/actions/vacancies/vacancy-documents/index.js